import React, { useContext, useEffect, useState } from "react";

import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";

import { CompetenzaContext } from "../CompetenzaContext";

export const AssignmentDialog = ({
    open,
    handleClose,
    handleSubmit,
    ...props
}) => {
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box>{children}</Box>}
            </div>
        );
    }

    const {
        state,
        setState,

        isLoadingComuni,
        getComuniAsync,

        isLoadingRegioni,
        getRegioniAsync,

        isLoadingProvince,
        getProvinceAsync,
    } = useContext(CompetenzaContext);

    const {
        comuniOptions,
        ufficiOptions,
        competenza,
        regioni,
        regioniOptions,
        province,
        provinceOptions,
    } = state;

    const [assignmentComuni, setAssignmentComuni] = useState([]);

    const [assignmentUfficio, setAssignmentUfficio] = useState(null);
    const [assignmentComune, setAssignmentComune] = useState(null);

    const [assignmentRegione, setAssignmentRegione] = useState(null);
    const [assignmentProvincia, setAssignmentProvincia] = useState(null);

    const [validComuni, setValidComuni] = useState(true);
    const [invalidComuni, setInvalidComuni] = useState(false);

    const [assignmentType, setAssignmentType] = useState(0);

    useEffect(() => {
        if (assignmentComune) {
            setAssignmentComuni([...assignmentComuni, assignmentComune]);
        }
    }, [assignmentComune]);

    useEffect(() => {
        if (assignmentRegione)
            setState({
                provinceOptions: province.result
                    .filter((e) => e.regioneId === assignmentRegione.regioneId)
                    .map((e) => {
                        return {
                            provinciaId: e.id,
                            label: `${e.descrizione} (${e.sigla}) ${e.fineValidita
                                    ? `(${e.fineValidita.getDate()}-${e.fineValidita.getMonth() + 1
                                    }-${e.fineValidita.getFullYear()})`
                                    : ""
                                }`,
                        };
                    })
                    .sort((a, b) => a.label.localeCompare(b.label)),
            });
    }, [assignmentRegione]);

    return (
        <>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Assegna le competenze</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Scegli l'ufficio e i comuni da dover assegnare
                    </DialogContentText>
                    {competenza?.ufficioDefaultId ? (
                        <Typography marginTop={4} marginLeft={1}>
                            Ufficio di default: "{competenza.ufficioDefault.nome}"
                        </Typography>
                    ) : (
                        <Autocomplete
                            component={Autocomplete}
                            options={ufficiOptions}
                            onChange={(e, value) => {
                                setAssignmentUfficio(value);
                            }}
                            value={assignmentUfficio}
                            renderInput={(params) => (
                                <TextField {...params} label="Ufficio" />
                            )}
                            fullWidth
                            sx={{ marginTop: 2 }}
                        />
                    )}
                    <Tabs
                        value={assignmentType}
                        onChange={(e, value) => setAssignmentType(value)}
                    >
                        <Tab label="Manuale" />
                        <Tab label="Territorio" />
                        <Tab label="Tutti" />
                    </Tabs>
                    <TabPanel value={assignmentType} index={0}>
                        <Autocomplete
                            onInputChange={(e, value) => getComuniAsync(value)}
                            component={Autocomplete}
                            options={comuniOptions}
                            onChange={(e, value) => {
                                setAssignmentComune(value);
                            }}
                            value={assignmentComune}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Comuni"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {isLoadingComuni ? (
                                                    <CircularProgress size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            fullWidth
                            sx={{ marginTop: 2 }}
                        />
                        {assignmentComuni &&
                            assignmentComuni.map((comune) => (
                                <Chip
                                    label={comune.label}
                                    onDelete={() => {
                                        setAssignmentComuni(
                                            assignmentComuni.filter(
                                                (x) => x.comuneId != comune.comuneId
                                            )
                                        );
                                    }}
                                    sx={{ marginTop: 2 }}
                                />
                            ))}
                    </TabPanel>
                    <TabPanel value={assignmentType} index={1}>
                        <Autocomplete
                            component={Autocomplete}
                            options={regioniOptions}
                            onChange={(e, value) => {
                                setAssignmentRegione(value);
                                setAssignmentProvincia(null);
                            }}
                            value={assignmentRegione}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Regione"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {isLoadingRegioni ? (
                                                    <CircularProgress size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            fullWidth
                            sx={{ marginTop: 2 }}
                        />
                        <Autocomplete
                            component={Autocomplete}
                            options={provinceOptions}
                            onChange={(e, value) => {
                                setAssignmentProvincia(value);
                            }}
                            value={assignmentProvincia}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Provincia"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {isLoadingProvince ? (
                                                    <CircularProgress size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            fullWidth
                            sx={{ marginTop: 2 }}
                        />
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={validComuni}
                                        onChange={(e) => setValidComuni(!validComuni)}
                                    />
                                }
                                label="Attivi"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={invalidComuni}
                                        onChange={(e) => setInvalidComuni(!invalidComuni)}
                                    />
                                }
                                label="Non attivi"
                            />
                        </FormGroup>
                    </TabPanel>
                    <TabPanel value={assignmentType} index={2}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={validComuni}
                                        onChange={(e) => setValidComuni(!validComuni)}
                                    />
                                }
                                label="Attivi"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={invalidComuni}
                                        onChange={(e) => setInvalidComuni(!invalidComuni)}
                                    />
                                }
                                label="Non attivi"
                            />
                        </FormGroup>
                    </TabPanel>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Annulla</Button>
                    <Button
                        onClick={() => {
                            switch (assignmentType) {
                                case 0:
                                    handleSubmit(
                                        competenza?.ufficioDefaultId
                                            ? { ufficioId: competenza?.ufficioDefaultId }
                                            : assignmentUfficio,
                                        assignmentComuni
                                    );
                                    break;
                                case 1:
                                    handleSubmit(
                                        competenza?.ufficioDefaultId
                                            ? { ufficioId: competenza?.ufficioDefaultId }
                                            : assignmentUfficio,
                                        null,
                                        assignmentRegione?.regioneId,
                                        assignmentProvincia?.provinciaId,
                                        validComuni,
                                        invalidComuni
                                    );
                                    break;
                                case 2:
                                    handleSubmit(
                                        competenza?.ufficioDefaultId
                                            ? { ufficioId: competenza?.ufficioDefaultId }
                                            : assignmentUfficio,
                                        assignmentComuni,
                                        null,
                                        null,
                                        validComuni,
                                        invalidComuni,
                                        true
                                    );
                                    break;
                            }
                        }}
                    >
                        Assegna
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
